/* eslint-disable */
export default {
  header: 'Ota yhteyttä tukeen',
  toggleTitle: '1. Ota virheidenseurantatila käyttöön',
  toggleDescription:
    'Tämä auttaa meitä paikantamaan ongelmasi mutta saattaa vaikuttaa jonkin verran sovelluksesi suorituskykyyn.',
  downloadTitle: '2. Lataa virheloki, kun olet toistanut ongelman.',
  downloadButton: 'Lataa',
  downloadDisabledTitle:
    'Ota virheidenseurantatila käyttöön, jotta voit ladata virhelokin.',
  sendTitle: '3. Lähetä loki tukitiimille',
  createSupportTicket: 'Luo tukipyyntö,',
  sendDescription:
    ' jos haluat ottaa yhteyttä tukitiimiimme. Lähetä sitten loki tukitiimille vianmääritystä varten.',
  privacyNotice:
    'Lataamalla ja lähettämällä lokin meille hyväksyt, että RingCentral käyttää tiettyjä lokeihin liittyviä tietoja vianetsintä- ja virheidenkäsittelytarkoituksiin. Lisätietoja siitä, miten RingCentral käsittelee henkilötietoja, saat tutustumalla ',
  privacyNoticeLink: 'käyttöehtoihin',
  and: ' ja ',
  privacyNoticeEnd: 'tietosuojailmoitukseen.',
  needLeavePage:
    'Voit poistua tältä sivulta, kun virheiden seuranta on käynnissä. Kun olet toistanut ongelman, palaa tälle sivulle ja lataa lokitiedostot.',
  downloading: 'Ladataan',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
